import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { faHeartbeat } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './PatientCareCenterButton.module.css';
import { patientActions } from '_actions';
import { CommonButton } from '_components';


class PatientCareCenterButton extends React.Component {

    openPatient(e) {
        this.props.openPatient(this.props.ptno);
        if( this.props.preventDefault ) {
            e.preventDefault();
        }
    }


    render() {
        let cls;
        cls = styles.button;

        if (this.props.className ) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title ? this.props.title : 'Patient Care Center'} onClick={e => this.openPatient(e)} size={this.props.size} className={cls} >
                <FontAwesomeIcon icon={faHeartbeat} transform="shrink-6" color="white" />
            </CommonButton>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        openPatient: bindActionCreators(patientActions.open, dispatch)
    };
}

const connectedPatientCareCenterButton = connect(null, mapDispatchToProps)(PatientCareCenterButton);
export { connectedPatientCareCenterButton as PatientCareCenterButton };
